import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: {},
  dropdownConfigs: {},
  sorting: {},
};

const dropdownSlice = createSlice({
  name: "dropdown",
  initialState,
  reducers: {
    setDropdownFilters: (state, { payload }) => {
      const { projectId, dropdownType, filters } = payload;
      if (!state.filters[projectId]) {
        state.filters[projectId] = {};
      }
      state.filters[projectId][dropdownType] = filters;
    },
    setDropDownSorting: (state, { payload }) => {
      const { projectId, sorting } = payload;
      if (!state.sorting) {
        state.sorting = {};
      }
      if (!state.sorting[projectId]) {
        state.sorting[projectId] = {};
      }
      state.sorting[projectId] = sorting;
    },
    resetDropdownFilters: (state) => {
      state.filters = {};
    },
    setDropDownConfigByProjectAndType: (state, { payload }) => {
      const { projectId, dropdownType, config } = payload;
      if (!state.dropdownConfigs[projectId]) {
        state.dropdownConfigs[projectId] = {};
      }
      state.dropdownConfigs[projectId][dropdownType] = config;
    },
    loadDropDownDBState: (state, action) => action.payload,
  },
});

export const {
  setDropdownFilters,
  resetDropdownFilters,
  setDropDownConfigByProjectAndType,
  loadDropDownDBState,
  setDropDownSorting,
} = dropdownSlice.actions;
export default dropdownSlice.reducer;
